/* List of Redux constants */
export const CANDIDATE_APPLICATIONS_SET_LIST = '@candidate-applications/set-list';
export const CANDIDATE_APPLICATIONS_SET_LIST_LOADING = '@candidate-applications/set-list-loading';
export const CANDIDATE_APPLICATIONS_RESET_LIST = '@candidate-applications/reset-list';
export const CANDIDATE_APPLICATIONS_SET_SCHOOLS = '@candidate-applications/set-schools';
export const CANDIDATE_APPLICATIONS_SET_COUNTRIES = '@candidate-applications/set-countries';
export const CANDIDATE_APPLICATIONS_SET_STATUS_STATS = '@candidate-applications/set-status-stats';
export const CANDIDATE_APPLICATIONS_SET_QUERY_PARAMS = '@candidate-applications/set-query-params';

/* List of Sagas constants */
export const CANDIDATE_APPLICATIONS_GET_LIST = '@candidate-applications/get-list';
export const CANDIDATE_APPLICATIONS_GET_SCHOOLS = '@candidate-applications/get-schools';
export const CANDIDATE_APPLICATIONS_GET_COUNTRIES = '@candidate-applications/get-countries';
export const CANDIDATE_APPLICATIONS_GET_STATUS_STATS = '@candidate-applications/get-status-stats';



// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-applications/types.js